import type { IconData } from '@stacksjs/iconify-core'

export const otherUiChat: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 16V0h16v13H3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiChat
